import { UnreachableCaseError } from 'ts-essentials';
import { JSX } from 'solid-js';
import { IconSize } from '../icon-size';

export type TempSvgIcon =
  | 'svg-cant'
  | 'svg-slope'
  | 'svg-compute-volume'
  | 'svg-cut-fill'
  | 'svg-xy'
  | 'svg-z'
  | 'svg-vertical'
  | 'svg-archive'
  | 'svg-assistant'
  | 'svg-cube-outline'
  | 'svg-map-outline'
  | 'svg-image-scene-outline'
  | 'svg-photo-360';

const ICON_SIZE_PX: Record<IconSize, number> = {
  'icon-tiny': 12,
  'icon-small': 16,
  'icon-medium': 24,
  'icon-large': 32,
  'icon-xlarge': 48,
};

export const getSvgIcon = (
  iconName: TempSvgIcon,
  iconSize: IconSize
): JSX.Element => {
  const width = ICON_SIZE_PX[iconSize];
  const height = ICON_SIZE_PX[iconSize];

  switch (iconName) {
    case 'svg-cut-fill':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.666 19.7211V21.1654H4.36816V19.6625L11.9883 13.5023L19.666 19.7211ZM22.0332 13.1615H2V10.6088H22.0332V13.1615ZM19.666 4.04431L11.9883 10.2679L4.36816 4.10193V2.59998H19.666V4.04431Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-compute-volume':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.768 8.87486V9.81764L14.672 11.0138L15.4481 10.5333L15.8387 11.2058L15.4039 11.4742L19.2205 13.8767L19.2212 13.6126H19.9804L19.9797 14.3544L20.3769 14.6046C20.8345 14.8925 20.8586 15.5534 20.4523 15.8814L20.371 15.9388L12.779 20.6197C12.577 20.7442 12.332 20.7644 12.1156 20.6788L12.0248 20.6356L3.67349 15.9547C3.17771 15.6769 3.14726 14.9716 3.58552 14.6423L3.66773 14.5882L4.03704 14.3763L4.03704 13.6126H4.79625L4.79625 13.9418L9.18448 11.4311L8.81857 11.2044L9.20918 10.5318L9.95204 10.9918L12.0087 9.81529V8.87486H12.768ZM10.8631 12.257L5.61003 15.2629L12.0087 18.8495V17.895H12.768V18.8064L18.5159 15.263L13.824 12.3103L13.8857 12.4165L12.7676 13.1081L12.768 14.7744H12.0087L12.0084 13.181L10.7716 12.4151L10.8631 12.257ZM12.768 15.5545V17.1148H12.0087V15.5545H12.768ZM19.9804 11.2722V12.8325H19.2212V11.2722H19.9804ZM4.79625 11.2722V12.8325H4.03704V11.2722H4.79625ZM12.3701 11.3954L11.45 11.9205L12.1238 12.3378H12.5345L13.206 11.9213L12.3701 11.3954ZM17.4012 9.32261L17.7918 9.9952L16.4898 10.8023L16.0991 10.1297L17.4012 9.32261ZM7.25613 9.3212L8.55817 10.1283L8.16756 10.8009L6.86552 9.99378L7.25613 9.3212ZM18.6536 6.90132L19.8234 7.62607L19.9804 7.72619V10.4921H19.2212L19.2206 9.10851L18.4428 9.59165L18.0522 8.91907L19.2206 8.19395V8.16728L18.263 7.57391L18.6536 6.90132ZM5.75732 6.76501L6.12087 7.45359L5.15691 8.00821L6.60512 8.91765L6.21451 9.59023L4.79552 8.69845L4.79625 10.4921H4.03704L4.03631 7.77847L5.75732 6.76501ZM12.768 6.53443V8.09472H12.0087V6.53443H12.768ZM16.7006 5.69068L18.0026 6.49778L17.612 7.17036L16.3099 6.36326L16.7006 5.69068ZM7.75684 5.63823L8.12039 6.32682L6.78738 7.078L6.42383 6.38942L7.75684 5.63823ZM14.7475 4.48004L16.0495 5.28713L15.6589 5.95971L14.3569 5.15262L14.7475 4.48004ZM9.75636 4.51146L10.1199 5.20004L8.7869 5.95123L8.42335 5.26264L9.75636 4.51146ZM12.8232 3.26904L14.0965 4.07649L13.7059 4.74907L12.7673 4.15929L12.768 5.75429H12.0087L12.0081 4.14752L10.7864 4.82445L10.4229 4.13587L12.0087 3.26904H12.8232Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-cant':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.746 6.91667C17.746 6.63949 17.6137 6.38413 17.4005 6.24976C17.1874 6.11539 16.9269 6.12317 16.7202 6.27008L2.41746 16.4367C2.16383 16.617 2.04588 16.9666 2.12833 17.2935C2.21079 17.6205 2.4737 17.8458 2.77279 17.8458H17.0755C17.4458 17.8458 17.746 17.5044 17.746 17.0833V6.91667ZM16.4051 16.3208H5.11048L16.4051 8.29241V16.3208Z"
            fill="currentColor"
          />
          <path
            d="M20.4115 6.24188L20.0981 6.74953L18.8445 9.11033L20.0971 9.06071L20.0945 15.0037L18.8419 15.0533L20.0935 17.3149L20.4064 17.7978L20.7197 17.2901L21.895 14.9324L20.7208 14.9789L20.7234 9.0359L21.8976 8.98938L20.7244 6.72472L20.4115 6.24188Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-slope':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.8218 7.00875C19.8218 6.73157 19.6896 6.47621 19.4764 6.34184C19.2632 6.20747 19.0027 6.21525 18.7961 6.36216L4.49333 16.5288C4.2397 16.7091 4.12174 17.0586 4.2042 17.3856C4.28665 17.7126 4.54957 17.9379 4.84866 17.9379H19.1514C19.5217 17.9379 19.8218 17.5965 19.8218 17.1754V7.00875ZM18.481 16.4129H7.18635L18.481 8.38449V16.4129Z"
            fill="currentColor"
          />
          <path
            d="M14.8825 6.06207L14.288 6.11194L11.6445 6.5076L12.4291 7.48523L7.64901 11.0165L6.86441 10.0389L5.79009 12.3898L5.5879 12.9285L6.18239 12.8787L8.77688 12.4219L8.04132 11.5054L12.8214 7.97405L13.557 8.89057L14.6803 6.60076L14.8825 6.06207Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-xy':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1426 14.3043L20 14.9127L19.1426 15.5221L15.1426 17.8053V15.5221H4.85742V17.8053L0.857422 15.5221L0 14.9127L0.857422 14.3043L4.85742 11.8678V14.3043H15.1426V11.8678L19.1426 14.3043ZM6.24707 4.66467L8.13184 1.66663H10.1699L7.36914 5.79944L10.3828 9.99963H8.22363L6.14941 6.84827L4.0752 9.99963H2.0498L5.00879 5.70178L2.23828 1.66663H4.3252L6.24707 4.66467ZM14.5498 5.09827L16.5381 1.66663H18.7168L15.5537 6.75647V9.99963H13.5459V6.81409L10.3828 1.66663H12.5742L14.5498 5.09827Z"
            fill="currentColor"
          />
          <mask
            id="mask0_6160_231503"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="20"
            height="17"
          >
            <path
              d="M19.1426 14.3043L20 14.9127L19.1426 15.5221L15.1426 17.8053V15.5221H4.85742V17.8053L0.857422 15.5221L0 14.9127L0.857422 14.3043L4.85742 11.8678V14.3043H15.1426V11.8678L19.1426 14.3043ZM6.24707 4.66467L8.13184 1.66663H10.1699L7.36914 5.79944L10.3828 9.99963H8.22363L6.14941 6.84827L4.0752 9.99963H2.0498L5.00879 5.70178L2.23828 1.66663H4.3252L6.24707 4.66467ZM14.5498 5.09827L16.5381 1.66663H18.7168L15.5537 6.75647V9.99963H13.5459V6.81409L10.3828 1.66663H12.5742L14.5498 5.09827Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_6160_231503)">
            <rect width="20" height="20" fill="currentColor" />
          </g>
        </svg>
      );
    case 'svg-z':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5332 2.52405L17.9688 6.52405H15.5332V13.4762H17.9688L15.5332 17.4762L14.9238 18.3336L14.3145 17.4762L12.0312 13.4762H14.3145V6.52405H12.0312L14.3145 2.52405L14.9238 1.66663L15.5332 2.52405ZM9.03125 7.3092L5.22559 12.4303H9.16699V14.1666H2.5V12.8248L6.41113 7.56995H2.73438V5.83362H9.03125V7.3092Z"
            fill="currentColor"
          />
          <mask
            id="mask0_6171_231523"
            style={{ 'mask-type': 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="2"
            y="1"
            width="16"
            height="18"
          >
            <path
              d="M15.5332 2.52405L17.9688 6.52405H15.5332V13.4762H17.9688L15.5332 17.4762L14.9238 18.3336L14.3145 17.4762L12.0312 13.4762H14.3145V6.52405H12.0312L14.3145 2.52405L14.9238 1.66663L15.5332 2.52405ZM9.03125 7.3092L5.22559 12.4303H9.16699V14.1666H2.5V12.8248L6.41113 7.56995H2.73438V5.83362H9.03125V7.3092Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_6171_231523)">
            <rect width="20" height="20" fill="currentColor" />
          </g>
        </svg>
      );
    case 'svg-vertical':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.703 0c.233 0 .422.168.422.375v23.25c0 .207-.189.375-.422.375h-.844c-.233 0-.421-.168-.421-.375V22.5H12.75v-.75h1.688V19.5h-2.532v-.75h2.531V16.5H12.75v-.75h1.688V13.5h-2.532v-.75h2.531V10.5H12.75v-.75h1.688V7.5h-2.532v-.75h2.531V4.5H12.75v-.75h1.688V1.5h-6.75v22.125c0 .207-.19.375-.422.375h-.844C6.189 24 6 23.832 6 23.625V.375C6 .168 6.189 0 6.422 0z"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-archive':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fill-rule="evenodd"
            d="m20.54 5.23-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27M12 17.5 6.5 12H10v-2h4v2h3.5zM5.93 4l-.81 1h13.75l-.94-1z"
          />
        </svg>
      );
    case 'svg-assistant':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.74625 17.281V22L7.83278 19.6315C6.26455 19.2924 4.83802 18.4715 3.74625 17.281ZM7.80294 4.34728L3.74625 2V6.69008C4.88411 5.44899 6.34921 4.66683 7.80294 4.34708M14.7287 11.9761C14.7287 14.8756 12.3872 17.2262 9.49886 17.2262C6.61048 17.2262 4.269 14.8756 4.269 11.9761C4.269 9.07649 6.61048 6.72595 9.49906 6.72595C12.3876 6.72595 14.7289 9.07649 14.7289 11.9761M15.9991 11.9671C15.9991 8.36363 13.0892 5.44246 9.49967 5.44246C5.9101 5.44246 3 8.36342 3 11.9671C3 15.5708 5.9099 18.4917 9.49946 18.4917C13.089 18.4917 15.9989 15.5705 15.9989 11.9671M16.9141 9.63203C17.3948 11.1635 17.3964 12.8265 16.9021 14.3751L21 12.0001C20.8063 11.8878 17.152 9.7698 16.9143 9.63203"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-cube-outline':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5575 4.51516L9.3975 1.60516C9.15 1.47016 8.85 1.47016 8.6025 1.60516L3.4425 4.51516L2.25 5.19016V12.3602C2.25 12.6377 2.4 12.8927 2.6475 13.0352L8.6025 16.3952C8.85 16.5302 9.15 16.5302 9.3975 16.3952L15.3525 13.0352C15.6 12.9002 15.75 12.6377 15.75 12.3602V5.19016L14.5575 4.51516ZM8.4 14.9477L3.435 12.1427V6.50266L8.4 9.30766V14.9477ZM8.9925 8.28766L4.065 5.50516L8.9925 2.72266L13.92 5.50516L8.9925 8.28766ZM14.55 12.1352L9.585 14.9327V9.29266L14.55 6.48766V12.1352Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-map-outline':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.7499 1.73982C15.6674 1.73982 15.5774 1.75482 15.4874 1.78482L11.4374 3.26982L6.71245 1.55232C6.62995 1.52232 6.53995 1.50732 6.45745 1.50732C6.37495 1.50732 6.29245 1.52232 6.20995 1.55232L2.00995 3.01482C1.70995 3.11982 1.50745 3.40482 1.50745 3.71982V15.5548C1.50745 15.9823 1.85995 16.3048 2.25745 16.3048C2.33995 16.3048 2.42995 16.2898 2.51995 16.2598L6.48745 14.7898L11.2049 16.4548C11.2874 16.4848 11.3699 16.4998 11.4524 16.4998C11.5349 16.4998 11.6099 16.4848 11.6849 16.4623L15.9674 15.0598C16.2749 14.9623 16.4849 14.6698 16.4849 14.3473L16.5074 2.48982C16.5074 2.06232 16.1474 1.73982 15.7499 1.73982ZM5.68495 13.4848L2.99995 14.4823V4.25232L5.68495 3.31482V13.4848ZM10.7024 14.6923L7.18495 13.4473V3.31482L10.7024 4.59732V14.6923ZM14.9774 13.7998L12.2024 14.7073V4.58232L14.9924 3.56232L14.9774 13.7998Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-image-scene-outline':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.46 6.705C6.15 6.705 6.7125 6.1425 6.7125 5.4525C6.7125 4.7625 6.15 4.2 5.46 4.2C4.77 4.2 4.2075 4.7625 4.2075 5.4525C4.2075 6.1425 4.77 6.705 5.46 6.705ZM13.53 0H1.5C0.675 0 0 0.675 0 1.5V13.53C0 14.355 0.675 15.03 1.5 15.03H13.53C14.355 15.03 15.03 14.355 15.03 13.53V1.5C15.03 0.675 14.355 0 13.53 0ZM13.53 13.53H1.5V1.5H13.53V13.53ZM2.64 12.5325H12.4425C12.8025 12.54 12.99 12.1125 12.75 11.8425L9.9375 8.715C9.7725 8.5275 9.48 8.5275 9.315 8.715L6.705 11.61L4.935 9.6375C4.77 9.45 4.4775 9.45 4.3125 9.6375L2.3325 11.835C2.0925 12.105 2.28 12.5325 2.64 12.5325Z"
            fill="currentColor"
          />
        </svg>
      );
    case 'svg-photo-360':
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.65137 8.08228C2.89521 7.8898 3.24917 7.93146 3.44165 8.17529C3.63412 8.41913 3.59246 8.7731 3.34863 8.96558C2.8268 9.37748 2.62504 9.77857 2.625 10.125C2.625 10.5968 3.01229 11.1753 3.99829 11.7034C4.58534 12.0178 5.33039 12.2805 6.1875 12.4643V12C6.18759 11.7805 6.31543 11.5805 6.51489 11.4888C6.71438 11.3971 6.94947 11.4302 7.11621 11.573L8.42871 12.698C8.55991 12.8105 8.63258 12.9773 8.625 13.1499C8.61736 13.3225 8.53038 13.4822 8.38989 13.5828L8.27344 13.6648C8.22891 13.7098 8.17757 13.7467 8.12036 13.7747L7.07666 14.5203C6.90538 14.6426 6.68012 14.6596 6.49292 14.5635C6.30556 14.4671 6.1875 14.2732 6.1875 14.0625V13.6121C5.14747 13.4094 4.21737 13.0967 3.46729 12.6951C2.37116 12.1081 1.5 11.2376 1.5 10.125C1.50005 9.30421 1.98113 8.61133 2.65137 8.08228ZM14.5583 8.17529C14.7389 7.94663 15.0613 7.89599 15.3017 8.04931L15.3486 8.08228L15.4717 8.18335C16.0769 8.69842 16.4999 9.35542 16.5 10.125C16.5 11.2376 15.6289 12.1081 14.5328 12.6951C13.405 13.299 11.8706 13.7042 10.1668 13.8318C9.85717 13.8548 9.58733 13.6228 9.564 13.3133C9.54075 13.0034 9.77347 12.7329 10.0832 12.7097C11.6757 12.5904 13.0474 12.2144 14.0017 11.7034C14.9877 11.1753 15.375 10.5968 15.375 10.125C15.3749 9.82186 15.2205 9.47687 14.8323 9.11938L14.6514 8.96558L14.6081 8.92749C14.4034 8.72914 14.3779 8.40389 14.5583 8.17529ZM10.0723 3C10.4414 3 10.7578 3.24609 10.8633 3.58008L11.0567 4.125H12.375C12.9902 4.125 13.5 4.63477 13.5 5.25V9.75C13.5 10.3828 12.9902 10.875 12.375 10.875H5.625C4.99219 10.875 4.5 10.3828 4.5 9.75V5.25C4.5 4.63477 4.99219 4.125 5.625 4.125H6.92579L7.11914 3.58008C7.22461 3.24609 7.54102 3 7.91016 3H10.0723ZM9 5.8125C8.38477 5.8125 7.83984 6.14648 7.52344 6.65625C7.22461 7.18359 7.22461 7.83398 7.52344 8.34375C7.83984 8.87109 8.38477 9.1875 9 9.1875C9.59768 9.1875 10.1426 8.87109 10.459 8.34375C10.7578 7.83398 10.7578 7.18359 10.459 6.65625C10.1426 6.14648 9.59768 5.8125 9 5.8125Z"
            fill="currentColor"
          />
        </svg>
      );
    default:
      throw new UnreachableCaseError(iconName);
  }
};
